import gql from 'graphql-tag';

export const CREATE = gql`
  mutation createCourse($input: CreateCourseInput!) {
    createCourse(input: $input)
  }
`;

export const UPDATE = gql`
  mutation updateCourse($input: UpdateCourseInput!) {
    updateCourse(input: $input)
  }
`;

export const DELETE = gql`
  mutation deleteCourse($input: DeleteCourseInput!) {
    deleteCourse(input: $input)
  }
`;

export const SUBMIT_FOR_REVIEW = gql`
  mutation submitForReviewCourse($input: SubmitForReviewCourseInput!) {
    submitForReviewCourse(input: $input)
  }
`;
export const UNPUBLISH = gql`
  mutation unpublishCourse($input: UnpublishCourseInput!) {
    unpublishCourse(input: $input)
  }
`;

export const REJECT = gql`
  mutation rejectCourse($input: RejectCourseInput!) {
    rejectCourse(input: $input)
  }
`;

export const APPROVE = gql`
  mutation approveCourse($input: ApproveCourseInput!) {
    approveCourse(input: $input)
  }
`;

export const UPDATE_COURCE_PRICE = gql`
  mutation updateCoursePrice($input: UpdateCoursePriceInput!) {
    updateCoursePrice(input: $input)
  }
`;
